import "./style.scss";
import { useEffect } from "react";
import { Control, Controller, ControllerRenderProps, FieldValues, Path } from "react-hook-form";
import ArrowSvg from "@/src/svg/autoCompile/ArrowSvg";
import {
  buildDegreeSelectOptions,
  DEFAULT_DEGREE_LEVEL,
  resolveDegreeValue,
} from "@/src/utils/admissionOffice/buildDegreeSelectOptions";

interface AOPDegreeSelectProps<T extends FieldValues> {
  control: Control<T>;
  name?: Path<T>;
}

interface DegreeSelectFieldProps<T extends FieldValues> {
  field: ControllerRenderProps<T, Path<T>>;
}

const DegreeSelectField = <T extends FieldValues>({ field }: DegreeSelectFieldProps<T>) => {
  useEffect(() => {
    if (!(field.value ?? "").trim()) {
      field.onChange(DEFAULT_DEGREE_LEVEL);
    }
  }, [field.value, field.onChange]);

  const value = resolveDegreeValue(field.value);

  return (
    <div className="aop-degree-select">
      <select
        id="degree"
        className="degree"
        value={value}
        onChange={(event) => field.onChange(event.target.value)}
        onBlur={field.onBlur}
        ref={field.ref}
      >
        {buildDegreeSelectOptions(value, "").map(({ value: optionValue, label, disabled, hidden }) => (
          <option key={`${optionValue}-${label}`} value={optionValue} disabled={disabled} hidden={hidden}>
            {label}
          </option>
        ))}
      </select>
      <div className="form-group-fields-input-svg">
        <div className="form-group-fields-input-svg-arrow">
          <ArrowSvg />
        </div>
      </div>
    </div>
  );
};

const AOPDegreeSelect = <T extends FieldValues>({ control, name = "degree" as Path<T> }: AOPDegreeSelectProps<T>) => (
  <Controller name={name} control={control} render={({ field }) => <DegreeSelectField field={field} />} />
);

export default AOPDegreeSelect;
